import { usePageTitle } from '@/features/_shared/usePageTitle'

// The page under /login. LoginModal opens itself whenever the app loads on
// /login or /login/*, so this route has nothing of its own to show — it exists
// so the catch-all NotFound doesn't render behind the modal (and log every
// visit to /login as a PageNotFound).
export function LoginPlaceholder() {
  usePageTitle('Log In')

  return (
    <div className="text-center py-16 text-gray-600">
      <p className="text-lg font-medium">Log in to continue</p>
    </div>
  )
}
